import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Header from "../components/header"
import Main from "../components/main"

const IndexPage = () => (
  <Layout>
    <SEO />
    <Header />
    <Main />
  </Layout>
)

export default IndexPage
